/**
 * Projects List Page - Redirect to Dashboard
 */

import { Navigate } from "react-router"

export default function ProjectsPage() {
  // Projects are shown on the dashboard
  return <Navigate to="/dashboard" replace />
}












